<ng-template #diningv2>
  <div
    [ngClass]="{
      'esg-icon': showIcon,
      'esg-container-v2': showContent,
      'esg-icon--horizontal': cardStyle === 'horizontal',
    }"
  >
    <div class="esg-container-v2-header">
      <mat-icon svgIcon="ten-esg"></mat-icon>
      <h4 class="typography-body-medium">{{ 'DetailsPageConsciousCollection:Header' | translate }}</h4>
    </div>
    <div
      *ngIf="showContent"
      [ngClass]="{
        'esg-content': isMobile && esgContentClosed,
        'esg-content-expanded': isMobile && !esgContentClosed,
      }"
    >
      {{ 'DetailsPageConsciousCollection' | translate }}
    </div>

    <div *ngIf="showContent && isMobile" class="read-more-text" (click)="toggleEsgContent()" role="button" tabindex="0">
      {{
        (esgContentClosed ? 'DetailsPageConsciousCollectionReadMore' : 'DetailsPageConsciousCollectionReadLess')
          | translate
      }}
    </div>
  </div>
</ng-template>

<ng-template #diningv1>
  <div
    [ngClass]="{
      'esg-icon': showIcon,
      'esg-container': showContent,
      'esg-icon--horizontal': cardStyle === 'horizontal',
    }"
  >
    <mat-icon svgIcon="ten-esg"></mat-icon>
    <div class="esg-content-wrapper">
      <div
        *ngIf="showContent"
        [ngClass]="{
          'esg-content': isMobile && esgContentClosed,
          'esg-content-expanded': isMobile && !esgContentClosed,
        }"
      >
        {{ 'DetailsPageConsciousCollection' | translate }}
      </div>

      <div
        *ngIf="showContent && isMobile"
        class="read-more-text"
        (click)="toggleEsgContent()"
        role="button"
        tabindex="0"
      >
        {{
          (esgContentClosed ? 'DetailsPageConsciousCollectionReadMore' : 'DetailsPageConsciousCollectionReadLess')
            | translate
        }}
      </div>
    </div>
  </div>
</ng-template>

<ng-container [ngSwitch]="esgTemplate">
  <ng-container *ngSwitchCase="'diningv2'">
    <ng-container *ngTemplateOutlet="diningv2"></ng-container>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="diningv1"></ng-container>
  </ng-container>
</ng-container>
